module.exports = __webpack_public_path__ + "img/not.5d94a326.svg";